<template lang="pug">
//- ProgressSpinner uses css class area-loading-spinner or mini-loading-spinner
.relative
  .area-loading-mask(v-if="loadingDebounced")
  ProgressSpinner(
    v-show="loadingDebounced"
    animationDuration=".5s"
    :class="spinnerCssClasses"
    strokeWidth="2"
    fill="transparent"
  )
  //- Contents of the loading area renders in the default slot:
  slot()
</template>

<script setup>
  import { computed, ref, watch } from 'vue'
  import _debounce from 'lodash/debounce'
  import ProgressSpinner from 'primevue/progressspinner'

  const props = defineProps({
    loading:   { type: Boolean, default: false },
    size:      { type: String, default: null },
    position:  { type: String, default: 'center' },
    immediate: { type: Boolean, default: true, required: false },
  })

  const spinnerCssClasses = computed(() => {
    let sizeClass = props.size == 'mini' ? 'mini-loading-spinner' : 'area-loading-spinner'
    let positionClass = (props.position == 'top') ? 'top-position' : ''
    return [sizeClass, positionClass].join(' ')
  });

  const loadingDebounced = ref(false)

  watch(() => props.loading, (val) => {
    // console.log('watch props', val)
    if (val) {
      loadingDebounced.value = val
    } else {
      _debounce(function () {
        loadingDebounced.value = val
      }, 250)()      
    }
  },
  { immediate: props.immediate })

</script>
